import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SelectUserComboBox from '../../../../components/SelectUserComboBox';
import cancelIcon from '../../../../assets/images/cancel-icon-gray.svg';
import dataModel from '../../../../models/DataModel';

import './LocationContact.scss';
import Input from '../../../../components/Input';

export class LocationContact extends React.Component {
  constructor(props) {
    LocationContact.propTypes = {
      /** Location_User object representing the location contact. User data/object is on contact.user  */
      contact: PropTypes.object,
      /** List of users in the market of the location's company  */
      locationMarketUsers: PropTypes.array,
      /** Delete locaiton user */
      handleDeleteLocationUser: PropTypes.func,
      /** Save or update location user */
      handleSaveLocationUser: PropTypes.func,

    };
    super(props);
    this.state = {
      changed: false,
      showSaveButton: this.props.contact ? false : true,
    };
    this.editedContact = Object.assign({}, props.contact);

    this.handleContactChanged = this.handleContactChanged.bind(this);
    this.handleTitleChanged = this.handleTitleChanged.bind(this);
    this.handleClickX = this.handleClickX.bind(this);
    this.handleSaveLocationUser = this.handleSaveLocationUser.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.contact && !this.props.contact) {
      this.editedContact = {};
    }
  }

  handleContactChanged(type, optionSelected) {
    this.editedContact.user = optionSelected.user;
    this.setState({ changed: true, showSaveButton: true });
  }

  handleTitleChanged(e) {
    this.editedContact.title = e.target.value;
    this.setState({ changed: true, showSaveButton: true });
  }

  handleClickX() {
    if (!this.props.contact) {
      // the form is for a new contact, so the 'X' should clear it
      this.editedContact.title = null;
      this.editedContact.user = null;
      this.setState({ changed: false });
    }
    else {
      // the form is for an exixting contact, so the 'X' should delete it
      this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: 'Are you sure you want to remove '+this.editedContact.user.first_name + ' ' + this.editedContact.user.last_name + ' as '+ this.editedContact.title +'?',
        height: 220,
        width: 320,
        cancelButtonText: 'CANCEL',
        okButtonText: 'YES',
        handleOwnerOk: () => this.props.handleDeleteLocationUser(this.editedContact.id),
      });
    }
  }

  handleSaveLocationUser() {
    if (this.state.changed && this.editedContact.title && this.editedContact.user) {
      const locationUserId = this.props.contact ? this.props.contact.id : null;
      this.props.handleSaveLocationUser(locationUserId, this.editedContact);
      this.setState({ showSaveButton: false });
    }
  }

  render() {
    let saveButton; 
    if (this.state.showSaveButton) {
      let saveButtonClassName = 'location-contact__save';
      if (this.state.changed && this.editedContact.title && this.editedContact.user) {
        saveButtonClassName += ' location-contact__save--enabled';
      }
      saveButton = (
        <div className={saveButtonClassName}
          onClick={this.handleSaveLocationUser}>
          SAVE 
        </div>
      );
    }
    return (
      <div  className='location-contact'>
        <div className='location-contact__title'>
          <div className="location-label">TITLE</div>

          <Input className='field' 
            value={this.editedContact.title || ''}
            onChange={this.handleTitleChanged}  //TODO
          />
        </div>
        <div className='location-contact__contact'>            
          <div className='location-label'>CONTACT</div>
          <SelectUserComboBox 
            users={this.props.locationMarketUsers}
            menuHeight={200}
            handleSelection={this.handleContactChanged}
            currentSelectedUser={this.editedContact.user}
            multiSelect={false}
            small={true}
            showSearchBar={true}
            searchHint={'Search Directory'}
            height={24}
            width={240}
          />
        </div>
        {saveButton}
        <div className='location-contact__clear' onClick={ this.handleClickX }>
          <img src={cancelIcon} alt="remove contact"/>
        </div> 
      </div>
    );
  }
}

export default connect( 
  (state) => ({
    dataModel: dataModel,
  })
)(LocationContact);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/LocationCRUD/LocationContact/index.js